import { isApiError } from 'features/common/api/apiError'
import { isTransientNetworkError } from 'features/common/api/utils'
import { EXPORTABLE_JOB_TYPES } from './constants'
import { JobType } from './types'

export function getLastTwentyFourHours() {
  const now = new Date()
  return new Date(now.setDate(now.getDate() - 1)).toString()
}

export function getLastYear() {
  const now = new Date()
  return new Date(now.setDate(now.getDate() - 365)).toString()
}

export function getTenYears() {
  const now = new Date()
  return new Date(now.setDate(now.getDate() - 3650)).toString()
}

export function shouldRetryJobOnError(error: unknown, errorCount: number) {
  return isTransientNetworkError(error) || (isApiError(error) && error.status === 500 && errorCount < 3)
}

export const isExportableJob = (type: JobType) => EXPORTABLE_JOB_TYPES.includes(type)
